// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
smart-docking-layout {
  width: 100%;
  height: 100%;
  border-radius: 0;
}
smart-splitter {
  border-radius: 0;
}
smart-splitter-bar[aria-orientation="horizontal"] {
  height: 1px !important;
}
smart-splitter-bar[aria-orientation="vertical"] {
  width: 1px !important;
}
smart-tab-item {
  padding: 0px!important;
}
smart-tab-item>.smart-container {
  padding: 0;
}
.smart-content {
  height: 100%!important;
}
.smart-graphileon-container-wrapper {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: auto;
}
.smart-tabs .smart-tabs-content-section {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
